export var PSWD_INPUT_STATE;
(function (PSWD_INPUT_STATE) {
  PSWD_INPUT_STATE[PSWD_INPUT_STATE["SHOW"] = 0] = "SHOW";
  PSWD_INPUT_STATE[PSWD_INPUT_STATE["HIDE"] = 1] = "HIDE";
})(PSWD_INPUT_STATE || (PSWD_INPUT_STATE = {}));